import React from 'react';
import { Clock, TrendingUp, Palette, BarChart3, Wrench } from 'lucide-react';

const CATEGORIES = [
  {
    id: 'save-time',
    label: 'Save Time',
    description: 'Automate repetitive tasks',
    icon: Clock,
    promptIntent: 'automate repetitive tasks and save time',
  },
  {
    id: 'grow-revenue',
    label: 'Grow Revenue',
    description: 'Marketing, sales, outreach',
    icon: TrendingUp,
    promptIntent: 'grow revenue through marketing, sales, and outreach',
  },
  {
    id: 'create-content',
    label: 'Create Content',
    description: 'Writing, images, videos',
    icon: Palette,
    promptIntent: 'create content including writing, images, and videos',
  },
  {
    id: 'get-insights',
    label: 'Get Insights',
    description: 'Analyze data, research',
    icon: BarChart3,
    promptIntent: 'analyze data, do research, and get insights',
  },
  {
    id: 'build-tools',
    label: 'Build Tools',
    description: 'Custom AI apps & agents',
    icon: Wrench,
    promptIntent: 'build custom AI tools, apps, and agents',
  },
];

export { CATEGORIES };

export default function CategoryFilterBar({ onAction, activeId }) {
  return (
    <div className="w-full max-w-4xl mx-auto">
      <div className="flex items-center md:justify-center gap-2 px-2 overflow-x-auto scrollbar-hide pb-1">
        {CATEGORIES.map((cat) => {
          const Icon = cat.icon;
          const isActive = activeId === cat.id;
          return (
            <button
              key={cat.id}
              onClick={() => onAction(cat)}
              className={`group flex items-center gap-2 md:gap-2.5 px-3 md:px-5 py-2.5 md:py-3 rounded-xl transition-all duration-200 flex-shrink-0 ${
                isActive
                  ? 'bg-white/10 border border-white/20 text-white'
                  : 'text-white/60 hover:text-white hover:bg-white/5 border border-transparent hover:border-white/[0.06]'
              }`}
            >
              <Icon className={`w-4 h-4 transition-colors duration-200 ${
                isActive ? 'text-teal-400' : 'text-white/40 group-hover:text-white/60'
              }`} />
              <span className="text-sm md:text-base font-medium whitespace-nowrap">{cat.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
